<div class="box">
  <div class="box-row header">
    <app-header-bar [autoTranslateTitle]="false" [title]="header" [backRoute]="'/software'"></app-header-bar>
  </div>

  <div class="d-flex flex-wrap align-items-center mt-2 mb-4"
    [ngClass]="{'justify-content-end': isAdmin}"
    >
    <span class="flex-grow-1 d-flex align-items-center mb-2">
      {{"search" | translate}}:
      <input type="text" class="form-control ms-3" id="software-search" [placeholder]="'software.searchContent' | translate" #input/>
    </span>
    @if (isAdmin) {
      <div class="d-flex justify-content-end flex-wrap ms-3">
        <a class="btn btn-nav me-3 mb-2" [routerLink]="['/software','types']">
          <span class="material-symbols-outlined">
            settings
          </span>
          <span>
            {{ 'software.manageTypes' | translate }}
          </span>
        </a>
        <a class="btn btn-nav me-3 mb-2" [routerLink]="['/software','platforms']">
          <span class="material-symbols-outlined">
            settings
          </span>
          <span>
            {{ 'software.managePlatforms' | translate }}
          </span>
        </a>
        <a class="btn btn-nav me-3 mb-2" [routerLink]="['/software','artifactReleaseTypes']">
          <span class="material-symbols-outlined">
            settings
          </span>
          <span>
            {{ 'software.manageReleaseTypes' | translate }}
          </span>
        </a>
        <button class="btn btn-nav mb-2" (click)="new()">
          <span class="material-symbols-outlined">
            add_box
          </span>
          <span>
            {{ 'new' | translate }}
          </span>
        </button>
      </div>
    }
  </div>

  <div class="box-row content mt-2">
    <div class="row ms-0 me-0 w-100">
      <app-error [error]="error"></app-error>
      @if (softwareSource.data) {
        @for (software of softwareSource.data.content; track software.id) {
          <app-software-item class="mb-4" [software]="software" (edit)="edit(software.id)" [isAdmin]="isAdmin"></app-software-item>
        }
      }
      <div class="paginator-wrapper">
        <mat-paginator [ngClass]="{'d-none': (softwareSource.loading | async) === false && !softwareSource.data?.content?.length}"></mat-paginator>
      </div>
      <app-model-modal #EditModal (saveEvent)="onSave()">
        <app-software-form (closeEvent)="onModalClose()"
        (loadingEvent)="onLoading($event.valueOf())"></app-software-form>
      </app-model-modal>
      @if ((softwareSource.loading | async) === false && softwareSource.count === 0) {
        <app-empty-table
          [icon]="'deployed_code'"
          [emptyText]="'software.empty_text' | translate"
        ></app-empty-table>
      }
    </div>
  </div>
</div>
